<div class="page">
  <app-page-site-switcher [inline]="inline" [variant]="'header'"></app-page-site-switcher>
  <!-- ====== TOP BLOCK ====== -->
  <div class="weekbar" *ngIf="!inline && !showProfileIaSubpage() && !showAjustementManuelSubpage()">
    <div class="weekbar-left">
      <!-- Espace vide pour alignement -->
    </div>
    <div class="weekbar-right">
      <button type="button" class="btn-primary-pill" (click)="openIaProfile()">
        <img class="ico" src="assets/IconORA.svg" alt="Ora" />
        {{ 'previsions.main.weekbar.configIa' | translate }}
      </button>
      <button type="button" class="btn-primary-pill" (click)="openManualAdjustment()">
        <img class="ico" src="/assets/modification.svg" alt="" />
        &nbsp;{{ 'previsions.main.weekbar.manualAdjustment' | translate }}
      </button>
    </div>
  </div>

  <!-- Fil d'Ariane pour la sous-page ProfileIA -->
  <div class="weekbar" *ngIf="!inline && showProfileIaSubpage()">
    <div class="breadcrumb">
      <button class="breadcrumb-back" (click)="closeProfileIaSubpage()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'previsions.main.breadcrumb.back' | translate }}
      </button>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'previsions.main.breadcrumb.previsions' | translate }}</span>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'previsions.main.breadcrumb.profileIa' | translate }}</span>
    </div>
  </div>

  <!-- Fil d'Ariane pour la sous-page AjustementManuel -->
  <div class="weekbar" *ngIf="!inline && showAjustementManuelSubpage()">
    <div class="breadcrumb">
      <button class="breadcrumb-back" (click)="closeAjustementManuelSubpage()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'previsions.main.breadcrumb.back' | translate }}
      </button>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'previsions.main.breadcrumb.previsions' | translate }}</span>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'previsions.main.breadcrumb.manualAdjustment' | translate }}</span>
    </div>
  </div>
  <!-- ====== /TOP BLOCK ====== -->

  <div *ngIf="!showProfileIaSubpage() && !showAjustementManuelSubpage()" style="margin-top: 16px;">
    <div class="layout">
      <!-- Colonne gauche : cartes récap -->
      <div class="left">
        <div class="info-card">
          <h4 class="title-violet">{{ 'previsions.main.forecastCard.title' | translate }}</h4>

          <div class="row">
            <div class="k">
              <div class="label">{{ 'previsions.main.forecastCard.tensionRate' | translate }}</div>
              <div class="val">{{ next().slotsOverHighCount != null ? next().slotsOverHighCount + ' %' : '—' }}</div>
            </div>
          </div>

          <div class="row">
            <div class="k">
              <div class="label">{{ 'previsions.main.forecastCard.nextOverHigh' | translate }}</div>
              <div class="val">{{ next().nextOverHighAt ?? '—' }}</div>
            </div>
          </div>

          <div class="row">
            <div class="k">
              <div class="label">{{ 'previsions.main.forecastCard.peakAt' | translate }}</div>
              <div class="val">{{ next().peakAt ?? '—' }}</div>
            </div>
          </div>

          <div class="row">
            <div class="k">
              <div class="label">{{ 'previsions.main.forecastCard.optimalArrival' | translate }}</div>
              <div class="val">{{ next().optimalArrivalTime ?? '—' }}</div>
            </div>
          </div>

          <div style="border-top: 1px solid #e5e7eb; margin: 16px 0;"></div>

          <div class="row">
            <div class="k">
              <div class="label">{{ 'previsions.main.forecastCard.updatedAt' | translate }}</div>
              <div class="val">{{ next().lastManualAdjustment ?? '—' }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Colonne droite : carte projection -->
      <div class="right">
        <!-- Sélecteur de jour -->
        <div class="day-selector">
          <button
            *ngFor="let day of days"
            class="day-btn"
            [class.active]="selectedDay() === day.value"
            (click)="selectDay(day.value)">
            {{ day.labelKey | translate }}
          </button>
        </div>

        <div class="card">
          <div class="card-header">
            <h3 class="title-violet">{{ 'previsions.main.projectionCard.title' | translate }}</h3>
            <div class="queue-selector">
              <select [value]="selectedQueueId()" (change)="onQueueChanged($any($event.target).value)">
                <option *ngFor="let queue of queues()" [value]="queue.id">
                  {{ queue.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="card-body">
            <app-forecast-graph
              [queueId]="selectedQueueId() ?? undefined"
              [bare]="true"
              [lowThreshold]="lowTh"
              [highThreshold]="highTh"
              [dayOfWeek]="selectedDay()"
              [showValues]="true"
              [customData]="$safeNavigationMigration(sharedForecastData()?.points)"
              [barColorLow]="'#513e9b'"
              [barColorMid]="'#f59e0b'"
              [barColorHigh]="'#ef4444'">
            </app-forecast-graph>
          </div>
        </div>

        <div class="info-card legend-card">
          <div class="legend">
            <span class="legend-item">
              <span class="legend-dot purple"></span>
              <span>{{ 'previsions.main.legend.normal' | translate }}</span>
            </span>
            <span class="legend-item">
              <span class="legend-dot orange"></span>
              <span>{{ 'previsions.main.legend.high' | translate }}</span>
            </span>
            <span class="legend-item">
              <span class="legend-dot red"></span>
              <span>{{ 'previsions.main.legend.peak' | translate }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sous-page ProfileIA -->
  <div class="profile-ia-subpage" *ngIf="showProfileIaSubpage()">
    <app-profile-ia></app-profile-ia>
  </div>

  <!-- Sous-page AjustementManuel -->
  <div class="ajustement-manuel-subpage" *ngIf="showAjustementManuelSubpage()">
    <app-ajustement-manuel></app-ajustement-manuel>

  </div>
</div>
